var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7559 21.1914H3.92188C2.11254 21.1914 0.640625 19.7195 0.640625 17.9102V6.79492C0.640625 4.98559 2.11254 3.51367 3.92188 3.51367H11.7559C13.5652 3.51367 15.0371 4.98559 15.0371 6.79492V17.9102C15.0371 19.7195 13.5652 21.1914 11.7559 21.1914ZM3.92188 5.1543C3.01729 5.1543 2.28125 5.89034 2.28125 6.79492V17.9102C2.28125 18.8147 3.01729 19.5508 3.92188 19.5508H11.7559C12.6604 19.5508 13.3965 18.8147 13.3965 17.9102V6.79492C13.3965 5.89034 12.6604 5.1543 11.7559 5.1543H3.92188ZM18.3184 15.8594V3.47266C18.3184 1.66332 16.8464 0.191406 15.0371 0.191406H5.93164C5.47855 0.191406 5.11133 0.558624 5.11133 1.01172C5.11133 1.46481 5.47855 1.83203 5.93164 1.83203H15.0371C15.9417 1.83203 16.6777 2.56807 16.6777 3.47266V15.8594C16.6777 16.3125 17.045 16.6797 17.498 16.6797C17.9511 16.6797 18.3184 16.3125 18.3184 15.8594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteCopy);
export default __webpack_public_path__ + "static/media/note-copy.badd97c649f6b8d4d371d58d69c3f646.svg";
export { ForwardRef as ReactComponent };